var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from "react";
// @ts-ignore
import { navigateNext } from "../../dataBase/stepProgress";
import { insuranceDTO } from "../../dataBase/insuranceType";
import { getCustomerAction } from "../../fnx/customer";
import { countries } from "../../store/countries/actions";
import { filterData, formatDocument, getInfo, getLogin, getVariables, transformToSelect, } from "../../services/functions";
import { useDispatch } from "react-redux";
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CustomerFormsView } from "./ui/view";
import { useLocation, useNavigate } from "react-router-dom";
import { region } from "../../store/region/actions";
import * as catalogConst from "../../const/catalog";
import { STEP_CUSTOMERFORM } from "../../const/catalog";
import { catalogGender } from "../../store/plan/actions";
import LocalStorageService from "../../services/localStorage";
import { quoteClearData } from "../../store/generateQuote/actions";
import { Steps } from "../../enum/steps";
import { themeCore } from "../../assets/themes/theme";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { useGetPlansAll } from "../../fnx/plans/plansGetAll";
import { paymentModeAction } from "../../store/paymentModes/action";
/* Selectors */
import useSelectors from "./components/selectors";
/* Customer */
import useCustomer from "./components/customer";
/* UI */
import useUI from "./components/ui";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { useGetInformationSteps } from "../../utils/getInformationStep";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { CustomerHeader } from "./ui/header";
import { useCompleteStep } from "../../utils/responseComplete";
var STEP = STEP_CUSTOMERFORM;
var storageKey2 = "assurehub";
var storageSteps = "afy-steps";
var lsLogin = new LocalStorageService(storageKey2);
var storageKeyVariables = "afy-variables";
var lsVariables = new LocalStorageService(storageKeyVariables);
var lsSteps = new LocalStorageService(storageSteps);
var CustomerForms = function () {
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var navigate = useNavigate();
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var storageKeySession = "assurehub";
    var localStorageServiceSession = new LocalStorageService(storageKeySession);
    var clientId = React.useState(getLogin().clientId)[0];
    var _e = React.useState(false), foundPerson = _e[0], setFoundPerson = _e[1];
    var variables = React.useState(getVariables()[0])[0];
    var _f = React.useState([]), breadCrumbs = _f[0], setBreadCrumbs = _f[1];
    var _g = React.useState(true), enable = _g[0], setEnable = _g[1];
    var _h = React.useState(1), page = _h[0], setPage = _h[1];
    var _j = React.useState(500), limit = _j[0], setLimit = _j[1];
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var _k = useState(false), trigger = _k[0], setTrigger = _k[1];
    var _l = React.useState({ id: "", name: "" }), paymentModelSelected = _l[0], setPaymentModelSelected = _l[1];
    var _m = React.useState(""), period = _m[0], setPeriod = _m[1];
    var _o = React.useState(), coverTypeSelected = _o[0], setCoverTypeSelected = _o[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var coverTypes = React.useState(findParamInLocalStorage("coverTypes"))[0];
    var _p = React.useState(Array.isArray(coverTypes) ? coverTypes[0] : coverTypes), coverType = _p[0], setCoverType = _p[1];
    var _q = React.useState(""), namePlan = _q[0], setNamePlan = _q[1];
    var _r = React.useState(false), renderComponent = _r[0], setRenderComponent = _r[1];
    var _s = React.useState(false), hideMarriedName = _s[0], setHideMarriedName = _s[1];
    var _t = useGetPlansAll(trigger, clientId, projectId || ""), responsePlansN = _t.responsePlansN, errorPlansN = _t.errorPlansN, loadingPlansN = _t.loadingPlansN;
    var _u = useCompleteStep(), runComplete = _u.runComplete, loadingComplete = _u.loadingComplete, responseComplete = _u.responseComplete, errorComplete = _u.errorComplete;
    var steps = useGetSteps();
    var _v = React.useState(), campaingSelected = _v[0], setCampaingSelected = _v[1];
    var _w = React.useState(findParamInLocalStorage("paymentMode")), paymentMode = _w[0], setPaymentMode = _w[1];
    var _x = React.useState(paymentMode), paymentSelected = _x[0], setPaymentSelected = _x[1];
    var _y = React.useState(), planSelected = _y[0], setPlanSelected = _y[1];
    var _z = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _z[0], setSeeToast = _z[1];
    var _0 = React.useState({
        title: "",
        data: [],
    }), insurance = _0[0], setInsurance = _0[1];
    var _1 = useState([]), listGenders = _1[0], setListGenders = _1[1];
    var _2 = useState([]), listCountries = _2[0], setListCountries = _2[1];
    var _3 = useState([]), listRegionLevel1 = _3[0], setListRegionLevel1 = _3[1];
    var _4 = useState([]), listRegionLevel2 = _4[0], setListRegionLevel2 = _4[1];
    var _5 = useState([]), listRegionLevel3 = _5[0], setListRegionLevel3 = _5[1];
    var _6 = React.useState(transformToSelect((_b = (_a = getInfo("steps", "Productos")) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.campaign[0])), campaignInfo = _6[0], setCampaignInfo = _6[1];
    var _7 = useState([]), filters = _7[0], setFilters = _7[1];
    var company = (_c = JSON.parse(localStorage.getItem("assurehub") || "{}")) === null || _c === void 0 ? void 0 : _c.subdomain;
    var isApap = getCustomerAction().customerAuto.includes(company);
    var summary = useGetSummary();
    var carDetails = React.useState()[0];
    var _8 = useState({
        Id: "",
        IdType: getVariables()[0].idType,
        Type: getVariables()[0].type,
        DocumentNumber: getVariables()[0].docNumber
            ? formatDocument(getVariables()[0].docNumber)
            : "",
        Name: "",
        SecondName: "",
        LastName: "",
        MarriedSurName: "",
        Gender: "",
        Birthday: "",
        Country: "",
        Province: "",
        Town: "",
        Sector: "",
        PostalCode: "",
        Address1: "",
        Address2: "",
        PhoneOffice: "",
        PhoneHome: "",
        PhoneNumber: "",
        Email: "",
    }), dataForm = _8[0], setDataForm = _8[1];
    var _9 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), plan = _9[0], setPlan = _9[1];
    var _10 = useSelectors(), responsePlan = _10.responsePlan, loading = _10.loading, responseCountries = _10.responseCountries, errorCountries = _10.errorCountries, responseRegion = _10.responseRegion, errorRegion = _10.errorRegion, loadingRegion = _10.loadingRegion, responseQuote = _10.responseQuote, errorQuote = _10.errorQuote, loadingQuote = _10.loadingQuote, responsePerson = _10.responsePerson, errorPerson = _10.errorPerson, responsePlans = _10.responsePlans, errorPlans = _10.errorPlans, responseCatalogGender = _10.responseCatalogGender, errorCatalogGender = _10.errorCatalogGender;
    var _11 = useUI(STEP, navigate), handleBack = _11.handleBack, showToast1 = _11.showToast1;
    var pathname = useLocation().pathname;
    var _12 = useGetInformationSteps(pathname), instanceId = _12.instanceId, workFlowId = _12.workFlowId, currentStep = _12.currentStep, nextStep = _12.nextStep;
    var _13 = useCustomer(coverTypeSelected, setCoverType, setPaymentSelected, setPlanSelected, responsePlansN, clientId, projectId, setHideMarriedName, enable, page, limit, level2, level3, listGenders, paymentMode, namePlan, paymentModelSelected, setPeriod, paymentSelected, coverType, setListRegionLevel3, Steps, campaingSelected, setCoverTypeSelected, setPaymentMode, setPaymentModelSelected, instanceId || "", workFlowId || "", currentStep || "", nextStep || "", runComplete), onAcquire = _13.onAcquire, handleChangeSelect = _13.handleChangeSelect, handleOnBlur = _13.handleOnBlur, handleChangeDocument = _13.handleChangeDocument, handleChangeProvince = _13.handleChangeProvince, handleChangeTown = _13.handleChangeTown, handleSubmit = _13.handleSubmit, choiceInsuranceType = _13.choiceInsuranceType, setCoverTypeStorybook = _13.setCoverTypeStorybook, onChangeCoverType = _13.onChangeCoverType, clickChangePaymentMode = _13.clickChangePaymentMode;
    var branchId = React.useState(findParamInLocalStorage("branchId"))[0];
    console.log("branchId", branchId);
    console.log("Plan", (_d = Plan === null || Plan === void 0 ? void 0 : Plan["0"]) === null || _d === void 0 ? void 0 : _d.id);
    useEffect(function () {
        if (variables === null || variables === void 0 ? void 0 : variables.docNumber) {
            if ((variables === null || variables === void 0 ? void 0 : variables.docNumber.length) > 3) {
                handleChangeDocument(variables === null || variables === void 0 ? void 0 : variables.docNumber);
            }
        }
    }, [variables]);
    useEffect(function () {
        if (!(responsePlansN === null || responsePlansN === void 0 ? void 0 : responsePlansN.data)) {
            setTrigger(true);
        }
        if (projectId)
            dispatch(paymentModeAction({ enable: enable, page: page, limit: limit, projectId: projectId }));
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var campaignSelected;
        if (getCustomerAction().customerAuto.includes(((_a = getLogin()) === null || _a === void 0 ? void 0 : _a.subdomain) || "")) {
            if (((_c = (_b = getInfo("steps", "Productos")) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.campaign.length) > 0) {
                campaignSelected = (_e = (_d = getInfo("steps", "Productos")) === null || _d === void 0 ? void 0 : _d.details) === null || _e === void 0 ? void 0 : _e.campaign[0];
            }
        }
        else {
            campaignSelected = (_g = (_f = getInfo("steps", "Productos")) === null || _f === void 0 ? void 0 : _f.details) === null || _g === void 0 ? void 0 : _g.campaign[0];
        }
        if (typeof campaignSelected !== "string") {
            try {
                setCampaingSelected(campaignSelected);
            }
            catch (error) {
                console.error("Error al parsear campaignSelected:", error);
            }
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        dispatch(catalogGender({
            enable: enable,
            page: page,
            limit: limit,
            clientId: localStorageServiceSession.getUserLoginStored().clientId,
        }));
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (errorComplete) {
            setSeeToast({
                show: true,
                message: ((_b = (_a = errorComplete === null || errorComplete === void 0 ? void 0 : errorComplete.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.message)
                    ? (_d = (_c = errorComplete === null || errorComplete === void 0 ? void 0 : errorComplete.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message
                    : errorComplete === null || errorComplete === void 0 ? void 0 : errorComplete.message,
                type: typeAlert.error,
            });
        }
    }, [errorComplete]);
    useEffect(function () {
        var _a, _b;
        if (errorCatalogGender) {
            setSeeToast({
                show: true,
                message: ((_a = errorCatalogGender === null || errorCatalogGender === void 0 ? void 0 : errorCatalogGender.errors[0]) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = errorCatalogGender === null || errorCatalogGender === void 0 ? void 0 : errorCatalogGender.errors[0]) === null || _b === void 0 ? void 0 : _b.message
                    : errorCatalogGender === null || errorCatalogGender === void 0 ? void 0 : errorCatalogGender.message,
                type: typeAlert.error,
            });
        }
    }, [errorCatalogGender]);
    useEffect(function () {
        if (errorQuote && (errorQuote === null || errorQuote === void 0 ? void 0 : errorQuote.errors)) {
            showErrorToast(errorQuote, setSeeToast, t);
            console.log("errorQuote Cleared");
            dispatch(quoteClearData());
        }
    }, [errorQuote]);
    useEffect(function () {
        if (errorCountries) {
            showErrorToast(errorCountries, setSeeToast, t);
        }
    }, [errorCountries]);
    useEffect(function () {
        if (errorPerson) {
            showErrorToast(errorPerson, setSeeToast, t);
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorRegion) {
            showErrorToast(errorRegion, setSeeToast, t);
        }
    }, [errorRegion]);
    useEffect(function () {
        var _a, _b;
        if (errorPerson) {
            setSeeToast({
                show: true,
                message: ((_a = errorPerson === null || errorPerson === void 0 ? void 0 : errorPerson.errors[0]) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = errorPerson === null || errorPerson === void 0 ? void 0 : errorPerson.errors[0]) === null || _b === void 0 ? void 0 : _b.message
                    : errorPerson === null || errorPerson === void 0 ? void 0 : errorPerson.message,
                type: typeAlert.error,
            });
            setTimeout(function () {
                setSeeToast({
                    show: false,
                    message: "",
                    type: typeAlert.error,
                });
            }, 3000);
        }
    }, [errorPerson]);
    useEffect(function () {
        var _a, _b;
        if (errorRegion) {
            setSeeToast({
                show: true,
                message: ((_a = errorRegion === null || errorRegion === void 0 ? void 0 : errorRegion.errors[0]) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = errorRegion === null || errorRegion === void 0 ? void 0 : errorRegion.errors[0]) === null || _b === void 0 ? void 0 : _b.message
                    : errorRegion === null || errorRegion === void 0 ? void 0 : errorRegion.message,
                type: typeAlert.error,
            });
            setTimeout(function () {
                setSeeToast({
                    show: false,
                    message: "",
                    type: typeAlert.error,
                });
            }, 3000);
        }
    }, [errorRegion]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    //ANALIZAR SI ES NECESARIO TENER ESTO
    useEffect(function () {
        var _a, _b, _c;
        if (responseQuote && responseQuote.data) {
            localStorage.setItem("customer", JSON.stringify({
                id: ((_a = getInfo("steps", "Productos")) === null || _a === void 0 ? void 0 : _a.details.projectId) || "",
                name: ((_b = getInfo("steps", "Productos")) === null || _b === void 0 ? void 0 : _b.details.title) || "",
                step: Steps.customer,
                completed: true,
                quoteId: responseQuote.data.id,
                campaign: ((_c = getInfo("steps", "Productos")) === null || _c === void 0 ? void 0 : _c.details.campaign) || "",
                campaignSelected: campaingSelected,
                paymentMode: paymentMode,
                paymentModeSelected: paymentSelected,
                coverType: coverType,
            }));
            navigateNext(STEP, navigate);
            dispatch(quoteClearData());
        }
    }, [responseQuote]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_PAYMENT_MODE);
            if (result.length > 0) {
                setPaymentModelSelected(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode[0]);
            }
        }
    }, [responsePlan]);
    useEffect(function () {
        setDataForm(__assign(__assign({}, dataForm), { Country: getLogin().countryId || "" }));
    }, [listCountries]);
    useEffect(function () {
        var _a;
        if (responseCountries === null || responseCountries === void 0 ? void 0 : responseCountries.data) {
            var data = (_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: getLogin().clientId,
            }));
        }
    }, [responseCountries]);
    useEffect(function () {
        if (insuranceDTO.data && insuranceDTO.data.length > 0) {
            setInsurance(insuranceDTO);
        }
    }, [insuranceDTO]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        var _a;
        if (responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data) {
            var data = (_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        if (listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            foundPerson === true &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0) {
            setRenderComponent(true);
        }
    }, [
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    useEffect(function () {
        if (listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            !foundPerson) {
            setRenderComponent(true);
        }
    }, [listGenders, listCountries, listRegionLevel1]);
    useEffect(function () {
        if (renderComponent) {
            setDataForm(__assign(__assign({}, dataForm), { renderComponent: true }));
        }
    }, [renderComponent]);
    useEffect(function () {
        var _a;
        if (responsePerson && ((_a = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setFoundPerson(true);
            var person_1 = responsePerson.data[0];
            handleChangeProvince(person_1.catalogRegionLevel1);
            handleChangeTown(person_1.catalogRegionLevel2);
            var gender = listGenders.find(function (g) { return g.id === person_1.catalogGender; });
            var hideMarriedName_1 = (gender === null || gender === void 0 ? void 0 : gender.name) !== "Femenino";
            setHideMarriedName(hideMarriedName_1);
            setDataForm(__assign(__assign({}, dataForm), { Id: person_1.id, 
                //IdType: person.identificationTypeId,
                //Country: person.countryId,
                Province: person_1.catalogRegionLevel1, Town: person_1.catalogRegionLevel2, Sector: person_1.catalogRegionLevel3, 
                //DocumentNumber: person.numberId,
                Name: person_1.firstNameA, SecondName: person_1.firstNameB, FirstLastName: person_1.lastNameA, SecondLastName: person_1.lastNameB, MarriedSurName: hideMarriedName_1 ? "" : person_1.marriedName, PostalCode: person_1.zip, Address1: person_1.addressA, Address2: person_1.addressB, PhoneOffice: person_1.phone2, PhoneHome: person_1.phone1, PhoneNumber: person_1.phone3, Email: person_1.email, Birthday: person_1.dob, Gender: person_1.catalogGender }));
            handleChangeProvince("");
        }
        else {
            if ((responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.data) !== undefined) {
                setHideMarriedName(true);
                setFoundPerson(false);
                showToast1(true, t("customer.notfound"), typeAlert.info);
            }
        }
    }, [responsePerson]);
    useEffect(function () {
        var _a;
        if (responsePlans) {
            var dataST_1 = [];
            var pm_1 = (_a = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _a === void 0 ? void 0 : _a.name;
            if (period === undefined) {
                setPeriod(pm_1);
            }
            responsePlans.map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                    period: period || pm_1,
                    price: item.price ? (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount : "0",
                    textColor: "#3A56A1",
                });
            });
            setPlan(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [responsePlans]);
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFilters(newMap);
    }, [summary]);
    var onChangeOptions = function (value, label) { };
    return (_jsxs(React.Fragment, { children: [_jsx(CustomerHeader, { loading: loading || loadingQuote || loadingRegion || loadingComplete, setSeeToast: setSeeToast, seeToast: seeToast }), _jsx(PagesHeader, { titlePage: "Validar Cliente", hideStep: false, steps: steps }), renderComponent && (_jsx(Suspense, { children: _jsx(CustomerFormsView, { hideChangePlan: isApap, hideButtonChangeCampaing: getCustomerAction().customerAuto.includes(company), hideMarriedName: hideMarriedName, dataForm: dataForm, insurance: insurance, breadCrumbs: breadCrumbs, stepProgress: steps, TypeList: [], GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, hide2: true, hide1: true, hide3: true, insuranceLabel: "", insuranceValue: "", options1: paymentMode, options2: [], options3: campaignInfo, plans: plan.data, plan: plan, showPaymentMethod: true, paymentMethodData: paymentMode, handleOnBlur: handleOnBlur, handleSubmit: handleSubmit, handleBack: handleBack, onClick: choiceInsuranceType, onChangeOptions: onChangeOptions, onChangeSelect: handleChangeSelect, clickChangePaymentMode: clickChangePaymentMode, onChangeCoverType: onChangeCoverType, onAcquire: onAcquire, filters: filters, isApap: isApap, showClientActions: !foundPerson, editClientMode: !foundPerson }) }))] }));
};
export default CustomerForms;
